import gql from 'graphql-tag';

export const GET_FILE_UPLOAD_URL = gql`
  mutation GetFileUploadUrl($filename: String!) {
    getFileUploadUrl(filename: $filename) {
      presignedUrlData
      file {
        id
        url
      }
    }
  }
`;

export const CREATE_RELEASE = gql`
  mutation CreateRelease($input: CreateReleaseInput!) {
    createRelease(input: $input) {
      error
      message
      success
    }
  }
`;

export const UPDATE_RELEASE = gql`
  mutation UpdateRelease($input: UpdateReleaseInput!) {
    updateRelease(input: $input) {
      error
      message
      success
    }
  }
`;

export const DELETE_RELEASE = gql`
  mutation DeleteRelease($id: String!) {
    deleteRelease(id: $id) {
      error
      message
      success
    }
  }
`;

export const AI_HELP = gql`
  mutation AiQuery($context: String!, $input: String!) {
    generateCompletion(context: $context, input: $input) {
      success
      message
      error
    }
  }
`;
